import React, { useState, useContext, useRef } from 'react';
import firebase from '../firebase';
import { CurrentContext } from './CurrentContext';
import { Redirect } from 'react-router-dom';
import { UserContext } from './UserContext';
import useIsOnline from '../hooks/useIsOnline';
import LostConnection from './LostConnection';
import { TrailContext } from './TrailContext';
import { useEffect } from 'react';

function SetData(props) {
    const db = firebase.firestore();
    const [status, setStatus] = useState(1);
    const [offScreen, setOffScreen] = useState(false);
    const [current, setCurrent] = useContext(CurrentContext);
    const [user] = useContext(UserContext);
    const [trails,] = useContext(TrailContext);
    const isOnline = useIsOnline();

    const docName = useRef();

    docName.current = trails.find(trail => {
        if(trail.url === props.match.params.trail) {
            return true;
        } else {
            return false;
        }
    }).name;


    useEffect(() => {
        if(!current.pastReports) {
            const db = firebase.firestore();
            const docRef = db.collection('trails').doc(docName.current);
            docRef.get()
                .then(doc => {
                    console.log(doc.data())
                    setCurrent(doc.data());
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }, [current.pastReports, setCurrent])

    function handleChange(e) {
        setStatus(e.currentTarget.value);
    }

    function handleSubmit(e) {
        e.preventDefault();
        const time = Date.now();
        const data = {
            status,
            time,
            name: docName.current,
            pastReports: [{status, time, name: docName.current}, ...current.pastReports],
        };
        db.collection('trails').doc(docName.current).set(data)
            .then(function() {
                setOffScreen(true);
            })
            .catch(err => {
                console.log(err);
            });
    }

    if (!isOnline) {
        return (
            <LostConnection />
        )
    }

    if (!user) {
        return <Redirect to="/signin" />
    }

    if (offScreen) {
        return <Redirect to={`/trails/${props.match.params.trail}`} />
    }

    return (
        <div className="page">
            <div className="heading">
                <h1 className="headingTitle">Make a trail report for:</h1>
                <h1 className="reportPageSub">{docName.current}</h1>
            </div>
            <div className="formContainer">
                <h2 className="systemExplanation" style={{textAlign: 'center'}}>The system for rating trail conditions goes from 1 to 10. 1 is very wet and 10 is too dry. Ideal conditions are around a 5.</h2>
                <form className="updateTrailForm" onSubmit={handleSubmit}>
                    <div className="selectorContainer">
                        <select className="statusSelector" onChange={handleChange}>
                            <option value="1">1/10 trails have become a pond</option>
                            <option value="2">2/10 trails are very wet</option>
                            <option value="3">3/10 trails are very slippery</option>
                            <option value="4">4/10 trails are mildly slippery</option>
                            <option value="5">5/10 trails are perfect</option>
                            <option value="6">6/10 trails are a tiny bit dry</option>
                            <option value="7">7/10 trails have become quite dusty</option>
                            <option value="8">8/10 trails are very dusty</option>
                            <option value="9">9/10 trails are very dusty and cracked</option>
                            <option value="10">10/10 trails have become the desert</option>
                        </select>
                    </div>
                    <input className="submitStatus" type="submit"/>
                </form>
            </div>
        </div>
    )
}

export default SetData;